import { WellFullDetailsDTO, WellFullDetailsWithUniqueKeyDTO } from 'types/well';
import { InnerWellbore, InnerWellboreWithWellInfo } from 'types/wellbore';

export const getWellUniqueId = (well: WellFullDetailsDTO) =>
  JSON.stringify({ tuwi: well.tuwi, wellId: well.wellId });

export const getUnifiedWellName = (well: WellFullDetailsDTO) =>
  well.wellviewWellName ?? well.wellName ?? well.tuwi ?? well.wellId ?? '-';

export const getWellboreUniqueId = (wellbore: InnerWellbore) =>
  JSON.stringify({ tuwbi: wellbore.tuwbi, wellboreId: wellbore.wellboreId });

export const getUnifiedWellboreName = (wellbore: InnerWellbore) =>
  wellbore.wellviewWellboreName ??
  wellbore.wellboreName ??
  wellbore.tuwbi ??
  wellbore.wellboreId ??
  '-';

export const getWellboreLabel = (well: WellFullDetailsWithUniqueKeyDTO) => {
  return well?.wellviewWellName;
};

export type OptionType = { value: string; label: string; isActive?: boolean };
export type GroupType = { data: { label: string } };

export const getWellChoice = (well: WellFullDetailsDTO & { isActive?: boolean }): OptionType => ({
  value: getWellUniqueId(well),
  label: getUnifiedWellName(well),
  isActive: well.isActive,
});

const enrichWellWithKeyAndUnifiedName = (
  well: WellFullDetailsDTO,
): WellFullDetailsWithUniqueKeyDTO => ({
  ...well,
  key: getWellUniqueId(well),
  unifiedWellName: getUnifiedWellName(well),
});

export const enrichWellListWithKeysAndUnifiedNames = (
  wells: WellFullDetailsDTO[],
): WellFullDetailsWithUniqueKeyDTO[] => wells.map(enrichWellWithKeyAndUnifiedName);

export const getLastActiveWellbore = (well?: WellFullDetailsDTO) => well?.wellbores?.[0];

export const getEnrichedWellboreWithWellInfo = (
  wellbore: InnerWellbore,
  well: WellFullDetailsDTO,
): InnerWellboreWithWellInfo => ({ ...wellbore, well: { ...well, wellbores: undefined } });
